module.exports = __webpack_public_path__ + "img/weather.a6207144.svg";